var _style, _defs, _path, _path2, _path3, _path4, _path5, _defs2, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOpthamology(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 103 102",
    style: {
      enableBackground: "new 0 0 103 102"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;}\n\t.st1{display:inline;}\n\t.st2{clip-path:url(#SVGID_00000041982195854415349940000010641720320733671082_);}\n\t.st3{fill:#E86E7B;}\n\t.st4{clip-path:url(#SVGID_00000119808437073798975240000010776250175432103324_);}\n")), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 0.5,
    y: 0,
    width: 102,
    height: 102
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000099632341673408478700000008128584727555668879_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000099632341673408478700000008128584727555668879_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M98.2,93.5h-85c-1.1,0-2.2-0.4-3-1.2c-0.8-0.8-1.2-1.9-1.2-3v-85c0-1.1-0.4-2.2-1.2-3C7,0.4,5.9,0,4.8,0 s-2.2,0.4-3,1.2C0.9,2,0.5,3.1,0.5,4.2v85c0,3.4,1.3,6.6,3.7,9s5.6,3.7,9,3.7h85c1.1,0,2.2-0.4,3-1.2c0.8-0.8,1.2-1.9,1.2-3 s-0.4-2.2-1.2-3C100.5,93.9,99.4,93.5,98.2,93.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M64.3,85c1.1,0,2.2-0.4,3-1.2c0.8-0.8,1.2-1.9,1.2-3V51c0-1.1-0.4-2.2-1.2-3c-0.8-0.8-1.9-1.2-3-1.2 s-2.2,0.4-3,1.2S60,49.9,60,51v29.8c0,1.1,0.4,2.2,1.2,3C62,84.6,63.1,85,64.3,85z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M30.2,85c1.1,0,2.2-0.4,3-1.2c0.8-0.8,1.2-1.9,1.2-3V51c0-1.1-0.4-2.2-1.2-3s-1.9-1.2-3-1.2 s-2.2,0.4-3,1.2S26,49.9,26,51v29.8c0,1.1,0.4,2.2,1.2,3C28,84.6,29.1,85,30.2,85z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M81.2,85c1.1,0,2.2-0.4,3-1.2c0.8-0.8,1.2-1.9,1.2-3v-51c0-1.1-0.4-2.2-1.2-3c-0.8-0.8-1.9-1.2-3-1.2 s-2.2,0.4-3,1.2c-0.8,0.8-1.2,1.9-1.2,3v51c0,1.1,0.4,2.2,1.2,3C79,84.6,80.1,85,81.2,85z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M47.2,85c1.1,0,2.2-0.4,3-1.2c0.8-0.8,1.2-1.9,1.2-3v-51c0-1.1-0.4-2.2-1.2-3s-1.9-1.2-3-1.2 s-2.2,0.4-3,1.2c-0.8,0.8-1.2,1.9-1.2,3v51c0,1.1,0.4,2.2,1.2,3C45,84.6,46.1,85,47.2,85z"
  }))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000085215089049530098160000004897959112513463995_",
    x: 9,
    y: 8.5,
    width: 85,
    height: 85
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000072993704535232176570000001087962174034860169_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000085215089049530098160000004897959112513463995_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000072993704535232176570000001087962174034860169_)"
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M91.5,41.8c-5.7-8.9-18.1-24.1-40-24.1s-34.4,14.9-40,24.1C9.7,44.6,9,47.8,9,51s1.1,6.4,2.5,9.2 c5.7,8.9,18.1,24.1,40,24.1s34.4-14.9,40-24.1c1.8-2.8,2.5-6,2.5-9.2S93.3,44.6,91.5,41.8z M85.5,56.3 c-4.6,7.8-15.6,20.5-34,20.5c-18.4,0-29.1-12.8-34-20.5c-1.1-1.8-1.4-3.5-1.4-5.3s0.7-3.9,1.4-5.3c4.6-7.8,15.2-20.5,34-20.5 c18.4,0,29.1,12.8,34,20.5c1.1,1.8,1.4,3.5,1.4,5.3S86.2,54.9,85.5,56.3z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5,33.3c-3.5,0-7.1,1.1-9.9,2.8c-2.8,2.1-5.3,4.6-6.4,7.8c-1.4,3.2-1.8,6.7-1.1,10.3s2.5,6.7,5,9.2 c2.5,2.5,5.7,4.3,9.2,5c3.5,0.7,7.1,0.4,10.3-1.1c3.2-1.4,6-3.5,7.8-6.4c2.1-2.8,2.8-6.4,2.8-9.9c0-4.6-1.8-9.2-5.3-12.4 C60.7,35.1,56.1,33.3,51.5,33.3z M51.5,61.6c-2.1,0-4.3-0.7-6-1.8c-1.8-1.1-3.2-2.8-3.9-4.6c-0.7-1.8-1.1-4.3-0.7-6 c0.4-2.1,1.4-3.9,2.8-5.3c1.4-1.4,3.5-2.5,5.3-2.8c2.1-0.4,4.3-0.4,6,0.7c1.8,0.7,3.5,2.1,4.6,3.9c1.1,1.8,1.8,3.9,1.8,6 c0,2.8-1.1,5.7-3.2,7.4C57.2,60.6,54.3,61.6,51.5,61.6z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpthamology);
export default __webpack_public_path__ + "static/media/Opthamology.548f9aa9d97496e76039a04a8bbcb188.svg";
export { ForwardRef as ReactComponent };